import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { Router } from '@angular/router';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-manage-banner',
  templateUrl: './manage-banner.component.html',
  styleUrls: ['./manage-banner.component.scss']
})
export class ManageBannerComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  searchValue: string;
  rowSelection
  rowData
  columnDefs
  private gridApi;
  private gridColumnApi;
  selectedRows: any;
  showUpdateRetailer: boolean;
  bannerId:any;
  constructor(private promotionService: PromotionsService, private router: Router) {
    super();
    this.getAllBannersData()
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  getAllBannersData() {
    this.promotionService.getPromotionBanners().subscribe(res => {
      if (res['httpcode'] == 200) {
        this.setGrid(res.data)
      }
    })
  }

  setGrid(data: any) {
    this.rowData = data;
    this.rowSelection = 'single';

    this.columnDefs = [
      { field: 'promotionBannerId', headerName: 'promotionBannerId', width: 0, hide: true, sort: "desc" },
      { field: '', headerName: 'Action', width: 160, checkboxSelection: true },
      { field: 'promotionName', headerName: 'Promotion Name', width: 240 },
      { field: 'promitionDescription', headerName: 'Promition Description', width: 300 },
      { field: 'promocodeStartDate', headerName: 'Promotion Start Date', width: 240 },
      { field: 'promocodeEndDate', headerName: 'Promotion End Date', width: 240 },
      { field: 'displayBanner', headerName: 'Display Banner', width: 240 }
    ]
  }

  // On grid ready
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  managePromotion() {
   
    this.router.navigate([`features/promotions/banner-config/edit-banner/${this.bannerId}`])
  }
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();

    if (this.selectedRows  && this.selectedRows.length > 0) {
      this.showUpdateRetailer = true;
      this.bannerId = this.selectedRows[0].promotionBannerId;

      return
    }
    this.showUpdateRetailer = false;
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  addPromotionConfig() {
    this.router.navigate([`features/promotions/banner-config/add-banner`])
  }


}

